import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { schema, uiSchema, translateSchema } from './config';
import BuilderForm from '../FormCarbon';
import NotFound from '../NotFound';
import DataTable from '../DataTable';
import {
  addUser,
  disableUser,
  handleUserSession,
  editUserAttributes
} from '../../../actions';
import axios from 'axios';
import { URL_BASE } from '../../../constants/api_urls';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

const Users = ({
  configFile,
  tempConfigFile,
  usersList,
  saveNewUser,
  deleteUser,
  changeUserAttributes
}) => {
  const [open, setOpen] = React.useState(false);
  const [notification, setNotification] = React.useState(null);
  const [formData, setFormData] = React.useState({});

  const config = tempConfigFile || configFile;
  const users = usersList
    ? Object.keys(usersList).map(e => parseUsers(usersList[e]))
    : [];

  const disableBuilder = config.disableBuilder;

  const rows = users;

  const headers = [
    { header: 'Nombre', key: 'name' },
    { header: 'username', key: 'username' },
    { header: 'Role', key: 'role' },
    { header: 'onlyOwn', key: 'onlyOwn' },
    { header: 'Email', key: 'email' },
    { header: 'phoneNumber', key: 'phoneNumber' },
    { header: 'status', key: 'status' }
  ];

  useEffect(() => {
    translateSchema(schema);
  }, []);

  function parseUsers (user) {
    return {
      id: user.id,
      username: user.username,
      name: user.name,
      role: user.apps.find(app => app.type === 'GOUZE').subgroups.find(subgroup => subgroup.default === true).role,
      phoneNumber: user.phoneNumber,
      onlyOwn: user.onlyOwn || 'false',
      email:
        user.email,
      status: user.status ? user.status : 'ACTIVE'
    };
  }

  const toggleForm = () => {
    setOpen(!open);
    if (open) {
      setFormData({});
      schema.properties.name.readOnly = false;
      schema.properties.phoneNumber.readOnly = false;
      schema.properties.email.readOnly = false;
    }
  };

  const onAdd = async ({ formData }) => {
    const token = await handleUserSession();
    const userNew = {
      username: formData.username,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      name: formData.name,
      role: formData.role,
      onlyOwn: formData.onlyOwn.toString()
    };
    axios
      .post(
        `${URL_BASE}/user/create`,
        userNew,
        {
          headers: {
            'X-Api-Key': token.decodePayload().apiKey,
            Authorization: `Bearer ${token.getJwtToken()}`
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          saveNewUser(response.data.data);
          toggleForm();
          setNotification({
            type: 'success',
            message: funcTranslateHelper('Builder.Message.realizado')
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          const { errors } = error.response.data;
          if (errors) {
            const [{ code }] = errors;
            toggleForm();
            setNotification({
              type: 'error',
              message: funcTranslateHelper(`Builder.Message.${code}`)
            });
          }
        } else {
          toggleForm();
          setNotification({
            type: 'error',
            message: funcTranslateHelper('Builder.Message.error')
          });
        }
      });
  };

  const onDelete = async id => {
    const token = await handleUserSession();
    const user = rows.find(user => user.id === id);
    axios
      .post(
        `${URL_BASE}/user/disable`,
        {
          username: user.username
        },
        {
          headers: {
            'X-Api-Key': token.payload.apiKey,
            Authorization: `Bearer ${token.getJwtToken()}`
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          deleteUser(response.data.data);
          setNotification({
            type: 'success',
            message: funcTranslateHelper('Builder.Message.realizado')
          });
        }
      })
      .catch(() => {
        setNotification({
          type: 'error',
          message: funcTranslateHelper('Builder.Message.error')
        });
      });
  };

  const openEdit = id => {
    const user = rows.find(user => user.id === id);
    setFormData(user);
    schema.properties.name.readOnly = true;
    schema.properties.username.readOnly = true;

    toggleForm();
  };

  const onEdit = async ({ formData }) => {
    const token = await handleUserSession();
    const user = rows.find(user => user.email === formData.email);
    const changedUser = {
      username: user.username,
      name: user.name,
      id: user.id,
      email: formData.email,
      role: formData.role,
      onlyOwn: formData.onlyOwn,
      phoneNumber: formData.phoneNumber
    };
    axios
      .post(
        `${URL_BASE}/user/changeAttributes`,
        changedUser,
        {
          headers: {
            'X-Api-Key': token.decodePayload().apiKey,
            Authorization: `Bearer ${token.getJwtToken()}`
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          changeUserAttributes(response.data.data);
          setNotification({
            type: 'success',
            message: funcTranslateHelper('Builder.Message.realizado')
          });
        }
      })
      .catch(() => {
        setNotification({
          type: 'error',
          message: funcTranslateHelper('Builder.Message.error')
        });
      });
    toggleForm();
  };

  if (!config.roles || !config.roles.length) { return <div>Debe añadir roles</div>; }

  schema.properties.role.enumNames = config.roles.map(role => role.name);
  schema.properties.role.enumNames.unshift(funcTranslateHelper('Builder:Users:form:chooseOption'));
  schema.properties.role.enum = config.roles.map(role => role.name);
  schema.properties.role.enum.unshift('');

  if (open) {
    return (
      <BuilderForm
        onAdd={onAdd}
        onClose={toggleForm}
        onEdit={onEdit}
        open={open}
        title={funcTranslateHelper('Builder.Users.form.titulo')}
        subtitle={funcTranslateHelper('Builder.Users.form.subtitulo')}
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        primaryButtonText={funcTranslateHelper('Guardar')}
        secondaryButtonText={funcTranslateHelper('Cancelar')}
      />
    );
  }

  if (!users || users.length === 0) {
    return (
      <NotFound
        title={funcTranslateHelper('Builder.Users.titulo')}
        subtitle={funcTranslateHelper('Builder.Users.subtitulo')}
        handleOpen={toggleForm}
        notification={notification}
        message={funcTranslateHelper('Builder:Users:addUser')}
      />
    );
  }

  return (
    <div className='data-table-container'>
      <DataTable
        title={funcTranslateHelper('Builder.Users.titulo')}
        subtitle={funcTranslateHelper('Builder.Users.subtitulo')}
        headers={headers}
        rows={rows}
        handleOpen={toggleForm}
        onDelete={onDelete}
        onEdit={openEdit}
        allowEdit={!disableBuilder}
        rawData={users}
        notification={notification}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile,
    usersList: state.users
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveNewUser: newUser => dispatch(addUser(newUser)),
    deleteUser: userEmail => dispatch(disableUser(userEmail)),
    changeUserAttributes: data => dispatch(editUserAttributes(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
